// extracted by mini-css-extract-plugin
export default {"root":"EditAdminPage_root__wrD9b","tabs":"EditAdminPage_tabs__XtPgP","tabItem":"EditAdminPage_tabItem__jG-HN"};